import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';
import { listElearnings } from 'src/common/services/elearning';
import { EventSearchCriteria } from 'src/common/models/eventSearchCriteria';
import { searchListPageSize } from 'src/config/listing';

export function useElearningList(
  criteria: EventSearchCriteria,
  page: number,
  pageSize: number = searchListPageSize,
) {
  const { key, isAuthenticated } = useCurrentUserKeyEnhancer([
    QueryKey.ElearningEventList,
    criteria,
    page,
    pageSize,
  ]);

  return useQuery(key, () => listElearnings(criteria, page, pageSize, isAuthenticated), {
    keepPreviousData: true,
  });
}
